import React, { useState, useEffect, memo } from "react";
import { useNavigate } from "react-router-dom";
import "react-loading-skeleton/dist/skeleton.css";
import LoadingSkeleton from "../../Component/react-loading-skeleteon/LoadingSkeleton";
import LazyImage from "./LazyImage";

export default memo(function CategoryCardPhysicalListing(props) {
  const categoryData = props.data;
  const navigate = useNavigate();
  const [imageLoading, setImageLoading] = useState(false);

  // Owner data combined (digital + physical)
  const ownerData =
    categoryData?.owner_id ||
    categoryData?.current_owner ||
    categoryData?.nft_id?.current_owner ||
    categoryData?.owner ||
    {};

  // Owner name
  const ownerName =
    ownerData?.name ||
    ownerData?.username ||
    categoryData?.item_info?.createdBy?.name ||
    categoryData?.nft_id?.createdBy?.name ||
    "Unknown Artist";

  // Owner image (unified for all tables)
  const ownerImage =
    ownerData?.profileImage?.water_mark_image_link ||
    ownerData?.profileImage?.link ||
    ownerData?.profileImage ||
    categoryData?.owner?.profileImage?.water_mark_image_link ||
    categoryData?.owner?.profileImage?.link ||
    categoryData?.owner?.profileImage ||
    categoryData?.item_info?.createdBy?.profileImage ||
    categoryData?.nft_id?.createdBy?.profileImage ||
    "/images/default-avatar.png";

  // Artwork Name
  const itemName =
    categoryData?.item_info?.name ||
    categoryData?.nft_id?.name ||
    categoryData?.name ||
    "Artwork";

  // Image extraction (physical + digital)
  const imageLink =
    categoryData?.listing_image?.water_mark_image_link ||
    categoryData?.listing_image?.link ||
    categoryData?.printable_image?.water_mark_image_link ||
    categoryData?.printable_image?.link ||
    categoryData?.media?.water_mark_image_link ||
    categoryData?.media?.link ||
    categoryData?.media?.image_link ||
    categoryData?.nft_id?.image_id?.image?.water_mark_image_link ||
    categoryData?.nft_id?.image_id?.image?.link ||
    categoryData?.nft_id?.image_id?.link ||
    categoryData?.nft_id?.image?.link ||
    categoryData?.item_info?.image ||
    categoryData?.item_info?.image_link ||
    categoryData?.item_info?.image_id?.link ||
    null;

  const viewCount = categoryData?.view_count || 0;
  const likeCount = categoryData?.like_count || 0;

  // Detect physical item
  const isPhysical = categoryData?.isPhysical === true || categoryData?.creator_wallet === "physical_artwork";

  // Price (only for digital)
  const itemPrice =
    categoryData?.price ||
    categoryData?.current_price ||
    categoryData?.nft_id?.price ||
    categoryData?.nft_id?.current_price ||
    null;

  // Image preload
  useEffect(() => {
    if (imageLink) {
      const img = new Image();
      img.onload = () => setImageLoading(true);
      img.onerror = () => setImageLoading(true);
      img.src = imageLink;
    } else {
      setImageLoading(true);
    }
  }, [imageLink]);

  // Navigation
  const handleNavigation = () => {
    if (isPhysical) {
      navigate(`/nftsale/physical/${categoryData?._id}`, {
        state: { isPhysical: true },
      });
    } else {
      const saleType = categoryData?.saleType || categoryData?.nft_id?.saleType;
      if (saleType === "auction") {
        navigate(`/liveAuctionNft/${categoryData?._id}`);
      } else {
        navigate(`/nftsale/${categoryData?._id}`);
      }
    }
  };

  return (
    <>
      {imageLoading ? (
        <div className="artItemBoxNew">
          <div
            className="imgBox"
            onClick={handleNavigation}
            style={{ cursor: "pointer" }}
          >
            {/* Owner info */}
            <div className="artistNameBox">
              <div className="d-flex align-items-center gap-2">
                <img
                  src={ownerImage}
                  alt={ownerName}
                  onError={(e) => (e.target.src = "/images/default-avatar.png")}
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <h5>
                  {ownerName?.length > 8
                    ? ownerName.slice(0, 8) + "..."
                    : ownerName}
                </h5>
              </div>
            </div>

            {/* Artwork Image */}
            {imageLink ? (
              <LazyImage src={imageLink} alt={itemName} />
            ) : (
              <div
                style={{
                  width: "100%",
                  aspectRatio: "1/1",
                  backgroundColor: "#E9ECEF",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#6C757D",
                  fontSize: "14px",
                  padding: "20px",
                  fontWeight: "500",
                }}
              >
                No Image Available
              </div>
            )}
          </div>

          {/* Content */}
          <div className="contBox">
            <div className="arthead">
              <h2 className="productName" title={itemName}>
                {itemName}
              </h2>
            </div>

            {/* Stats + Price */}
            <div className="artPriceBox align-items-start mt-2">
              <ul>
                <li>
                  <img src="/images/svg/eyeNew.svg" width="25" height="25" />
                  <h5>{viewCount}</h5>
                </li>

                <li>
                  <img src="/images/svg/likeNew.svg" width="25" height="25" />
                  <h5>{likeCount}</h5>
                </li>

                {/* ⭐ Price ONLY for digital NFTs | Show in $ */}
                {!isPhysical && itemPrice && (
                  <li className="d-flex align-items-center">
                    <span
                      style={{
                        fontSize: "18px",
                        fontWeight: "600",
                        marginRight: "4px",
                        lineHeight: "1",
                      }}
                    >
                      $
                    </span>
                    <h5>{itemPrice}</h5>
                  </li>
                )}
              </ul>
            </div>

            <button
              className="exploreBtn"
              onClick={handleNavigation}
              style={{ cursor: "pointer" }}
            > 
              Explore Now
            </button>
          </div>
        </div>
      ) : (
        <div className="artItemBoxNew">
          <div className="imgBox" style={{ aspectRatio: "1/1" }}>
            <LoadingSkeleton count={1} style={{ height: "100%" }} />
          </div>
        </div>
      )}
    </>
  );
});
